const name = 'module/ukrposhta';

export const GET_MODULES_CONFIGURATION_REQUEST = `${name}/GET_MODULES_CONFIGURATION_REQUEST`;
export const GET_MODULES_CONFIGURATION_SUCCESS = `${name}/GET_MODULES_CONFIGURATION_SUCCESS`;
export const GET_MODULES_CONFIGURATION_FAILURE = `${name}/GET_MODULES_CONFIGURATION_FAILURE`;

export const UPDATE_MODULES_CONFIGURATION_REQUEST = `${name}/UPDATE_MODULES_CONFIGURATION_REQUEST`;
export const UPDATE_MODULES_CONFIGURATION_SUCCESS = `${name}/UPDATE_MODULES_CONFIGURATION_SUCCESS`;
export const UPDATE_MODULES_CONFIGURATION_FAILURE = `${name}/UPDATE_MODULES_CONFIGURATION_FAILURE`;

export const CREATE_CLIENT_REQUEST = `${name}/CREATE_CLIENT_REQUEST`;
export const CREATE_CLIENT_SUCCESS = `${name}/CREATE_CLIENT_SUCCESS`;
export const CREATE_CLIENT_FAILURE = `${name}/CREATE_CLIENT_FAILURE`;

export const DELETE_CLIENT_REQUEST = `${name}/DELETE_CLIENT_REQUEST`;
export const DELETE_CLIENT_SUCCESS = `${name}/DELETE_CLIENT_SUCCESS`;
export const DELETE_CLIENT_FAILURE = `${name}/DELETE_CLIENT_FAILURE`;

export const GET_CLIENTS_REQUEST = `${name}/GET_CLIENTS_REQUEST`;
export const GET_CLIENTS_SUCCESS = `${name}/GET_CLIENTS_SUCCESS`;
export const GET_CLIENTS_FAILURE = `${name}/GET_CLIENTS_FAILURE`;

export const GET_CITIES_REQUEST = `${name}/GET_CITIES_REQUEST`;
export const GET_CITIES_SUCCESS = `${name}/GET_CITIES_SUCCESS`;
export const GET_CITIES_FAILURE = `${name}/GET_CITIES_FAILURE`;

export const CREATE_TTN_REQUEST = `${name}/CREATE_TTN_REQUEST`;
export const CREATE_TTN_SUCCESS = `${name}/CREATE_TTN_SUCCESS`;
export const CREATE_TTN_FAILURE = `${name}/CREATE_TTN_FAILURE`;

export const GET_TTN_MARKING_REQUEST = `${name}/GET_TTN_MARKING_REQUEST`;
export const GET_TTN_MARKING_SUCCESS = `${name}/GET_TTN_MARKING_SUCCESS`;
export const GET_TTN_MARKING_FAILURE = `${name}/GET_TTN_MARKING_FAILURE`;

export default name;
